module.exports = __webpack_public_path__ + "img/section4_item_bg.6fea702f.png";